import { makeStyles, tokens } from "@fluentui/react-components";

export const useOverflowMenuStyles = makeStyles({
  menu: {
    backgroundColor: tokens.colorNeutralBackground1,
    width: "fit-content",
  },
  menuButton: {
    alignSelf: "center",
  },
});
